import React, { useState, useEffect, useContext } from "react";
import "./AboutFalconSFX.css";
import { getCount } from "../../../utils/apis/common/Common";
import { AboutFalcon } from "../../../utils/apis/aboutus/Aboutus";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const AboutFalconSFX = () => {

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

   const { IMG_URL } = useContext(Context);

  const [counter, setCounter] = useState([]);

  const [aboutFalcon, setAboutFalcon] = useState([]);

  const getCounter = async () => {
    const res = await getCount();
    if (res?.success) {
      setCounter(res.data);
    }
  };

  const getAboutFalcon = async () => {
      const res = await AboutFalcon();
      if (res?.success) {
        setAboutFalcon(res.data);
      }
    };


  useEffect(() => {
    getCounter();
    getAboutFalcon();
  }, []);

  return (
    <section className="about-section AboutFalconSFX-section">
      <div className="container">
        <div className="bg-img-section">
          {aboutFalcon?.map((item, index) => (
          <div className="about-content">
            <div className="about-text">
              <p className="desc">
                {/* At Falcon SFX, we specialize in high-impact stage effects that
                transform ordinary events into extraordinary spectacles. From
                fire bursts to CO2 jets, we bring energy, drama, & excitement to
                every performance. */}
                {htmlToReactParser.parse(item?.description)}
              </p>
            </div>

            <div className="about-images">
              <img src={IDS?.IMG_URL + item?.image} alt="Stage Fire" />
            </div>
          </div>
          ))}
          {/* <div className="about-content">
            <div className="about-text">
              <p className="desc sec-desc">
                Whether it’s a concert, wedding, corporate show, or festival We
                deliver safe, reliable, and visually stunning effects.
              </p>
            </div>

            <div className="about-images">
              <img src="/assets/images/newhome/about1.png" alt="Stage Fire" />
            </div>
          </div> */}
        </div>
        <div className="stats-section">
          <div className="stats-container">
            {counter?.map((item, index) => (
              <div className="stat-item">
                <h2>{item?.count}</h2>
                <p className="text">{item?.name}</p>
              </div>
            ))}

            {/* <div className="stat-item">
              <h2>50,000+</h2>
              <p className="text">Special Effects Fired</p>
            </div>

            <div className="stat-item">
              <h2>05+</h2>
              <p className="text">years of experience</p>
            </div>

            <div className="stat-item">
              <h2>100%</h2>
              <p className="text">Safety Record</p>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutFalconSFX;
